import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'amfori_credentials_revoked_at'

export const dataPointDefinition = {
  retracedId: 'amfori_credentials_revoked_at',
  name: 'amfori Credentials Revoked At',
  description:
    'ISO-8601 timestamp recording when amfori rejected the stored credentials as revoked (an exhausted 403 during a sync). Presence marks the credentials as revoked and excludes the brand from the weekly sync until new credentials are saved, which clears it.',
  meta: {integration: 'AMFORI'},
  fieldTypeId: 'DATE',
  type: 'GLOBAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [],
  sortingId: 37950,
  sectionId: '1.2',
  impactArea: 'Other IDs',
  impactAreaId: 'OTHER_IDS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
